import { getUrlQueryVar } from '@/libs/util.js'

export const hsqAppid = 'hsq20181101475615'
export const omgAppid = 'omg20190327666666'
export const o2oAppid = 'o2o20200324020020'
export const gumAppid = 'gum20210108121500'
export const gysAppid = 'gys20210823103813'
export const errAppid = 'errAppid'

let logoMap = {
  [omgAppid]: {
    theme: 'common',
    title: '中台管理后台-登录-多维度',
  },
  [hsqAppid]: {
    theme: 'common',
    title: '好食期-登录-多维度',
    mini: 'logo-mini-hsq',
    sub: {
      jsz: {
        theme: 'common',
        title: '巨食阵-商户后台登录-多维度',
        mini: 'logo-mini-jsz',
      },
      hsq: {
        theme: 'common',
        title: '好食期-商户后台登录-多维度',
        mini: 'logo-mini-hsq',
      },
      admin: {
        theme: 'common',
        title: '好食期管理后台-多维度',
        mini: 'logo-mini-hsq',
      }
    },
  },
  [o2oAppid]: {
    theme: 'common',
    title: '聚客蜂-登录-多维度',
  },
  [gumAppid]: {
    theme: 'gum',
    title: '开放平台-登录-多维度',
  },
  [gysAppid]: {
    theme: 'gys',
    title: '供应商-登录-多维度',
  },
  [errAppid]: {
    theme: 'common',
    title: '多维度',
  },
}

let token = localStorage.getItem('passportToken') || ''

let dwd_appid = getUrlQueryVar('appId')
let sub_appid = getUrlQueryVar('subAppid')

let isGum = false
let isGys = false
if (dwd_appid === gumAppid) {
  isGum = true
}else if(dwd_appid === gysAppid){
  isGys = true
}

const _initSys = () => {
  let dwd_appid =
    commonParams.state.dwd_appid || getUrlQueryVar('appId', errAppid)
  let isGum = false
  if (dwd_appid === gumAppid) {
    isGum = true
  }

  let map = logoMap[errAppid]
  if (typeof logoMap[dwd_appid] != 'undefined') {
    map = logoMap[dwd_appid]
  }
  if (typeof map['sub'] != 'undefined') {
    const subAppid = getUrlQueryVar('subAppid')
    if (typeof map['sub'][subAppid] != 'undefined') {
      map = map['sub'][subAppid]
    }
  }
  let logoMiniCls = map['mini'] || ''
  let title = map['title'] || '多维度'
  let theme = map['theme'] || 'common'
  document.title = title
  let logoText = title.split('-')[0]
  commonParams.sys = {
    logoMiniCls,
    isGum,
    isGys,
    logoText,
    theme,
  }
}

export const commonParams = {
  state: {
    dwd_appid,
    token,
    sub_appid
  },
  sys: {
    init: false,
    logoMiniCls: '',
    isGum,
    isGys,
    logoText: '平台登录系统',
  },
  initSys() {
    _initSys()
  },
  setDwdAppidAction(dwd_appid) {
    this.state.dwd_appid = dwd_appid
    _initSys()
  },
  setTokenAction(token) {
    localStorage.setItem('passportToken', token)
    this.state.token = token
  },
}